import { Address } from 'viem';

import { USDC, WYLDS } from '@/app/shared/constants/web3/constants';

export interface SwapToken {
  address: Address | string;
  symbol: string;
  decimals: number;
  name?: string;
  logoURI?: string;
}

export const SELL_TOKEN: SwapToken = {
  address: USDC,
  symbol: 'USDC',
  decimals: 6,
};

export const BUY_TOKEN: SwapToken = {
  address: WYLDS,
  symbol: 'wYLDS',
  decimals: 6,
};

export const DEFAULT_PROTOCOL = 'Matcha/0x v2' as const;

export type SwapProtocol = typeof DEFAULT_PROTOCOL;

export const DEFAULT_PROTOCOL_CONFIG = {
  label: DEFAULT_PROTOCOL,
  logo: 'https://icons.llamao.fi/icons/protocols/0x?w=48&q=75',
};

export const SLIPPAGE_PRESETS = [
  { id: '0.02', label: '0.02%' },
  { id: '0.05', label: '0.05%' },
  { id: '0.1', label: '0.1%' },
] as const;

export const DEFAULT_SLIPPAGE = '0.05';

export const SLIPPAGE_MIN = 0.02;
export const SLIPPAGE_HIGH = 0.1;
export const PRICE_IMPACT_LOW = 1;
export const PRICE_IMPACT_HIGH = 3;
export const PRICE_IMPACT_TOO_LARGE = 15;
